const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const ReceivedTransfersFilters = require('./receivedTransfersFilters/receivedTransfersFilters');
const ReceivedTransfersContent = require('./receivedTransfersContent/receivedTransfersContent');

class ReceivedTransfers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filtersSectionOpen: false
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
    }

    componentDidMount() {
        const { requestReceivedTransfers, immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        requestReceivedTransfers(accountId);
    }

    componentDidUpdate(prevProps) {
         const accountId = this.props.immAccount.get('accountId');
         const prevAccountId = prevProps.immAccount.get('accountId');

         if (accountId !== prevAccountId) {
             const { requestReceivedTransfers } = this.props;
             requestReceivedTransfers(accountId);
         }
    }

    handleClearFilters() {
        const { immAccount, clearFilters, requestReceivedTransfers } = this.props;
        const accountId = immAccount.get('accountId');

        clearFilters();
        requestReceivedTransfers(accountId);
    }

    handleResetFilter(filters) {
        const { immAccount, resetFilter, requestReceivedTransfers } = this.props;
        const accountId = immAccount.get('accountId');
        //In same cases, we need to reset more than one filter at once
        filters.forEach(filter => {
            resetFilter(filter);
        });
        requestReceivedTransfers(accountId);
    }

    handleSetFilters(filters) {
        const { immAccount, setFilters, requestReceivedTransfers } = this.props;
        const accountId = immAccount.get('accountId');

        setFilters(filters);
        requestReceivedTransfers(accountId);
    }

    handleToggleFilters() {
        this.setState({
            filtersSectionOpen: !this.state.filtersSectionOpen
        });
    }

    render() {
        const {
            immAccount,
            immReceivedTransfers,
            immScreen,
            requestReceivedTransfersNextPage
        } = this.props;

        const immFilter = immReceivedTransfers.get('filters');
        const accountCurrency = immAccount.get('balance').get('currency');

        return (
            <div>
                <ReceivedTransfersFilters
                    accountCurrency={accountCurrency}
                    immFilter={immFilter}
                    isOpen={this.state.filtersSectionOpen}
                    onCloseClick={this.handleToggleFilters}
                    onSetFilters={this.handleSetFilters}
                />
                <ReceivedTransfersContent
                    immReceivedTransfers={immReceivedTransfers}
                    immAccounts={this.props.immAccounts}
                    immAccount={immAccount}
                    immFilter={immFilter}
                    immScreen={immScreen}
                    onFilterClick={this.handleToggleFilters}
                    onResetFilter={this.handleResetFilter}
                    onClearFilters={this.handleClearFilters}
                    requestReceivedTransfersNextPage={requestReceivedTransfersNextPage}
                />
            </div>
        );
    }
}

ReceivedTransfers.propTypes = {
    immReceivedTransfers: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    requestReceivedTransfers: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    requestReceivedTransfersNextPage: PropTypes.func.isRequired
}

module.exports = ReceivedTransfers;
